var resizeTimer;
var xsD = document.getElementById('device-xs');
var smD = document.getElementById('device-sm');
var mdD = document.getElementById('device-md');
var lgD = document.getElementById('device-lg');
var xlD = document.getElementById('device-xl');

/**
 * Method: checkBreakpoint
 *
 * Fires breakpoint event with information about current 
 * bootstrap size
 *
 * @return void
 */
function checkBreakpoint()
{
  var event = new CustomEvent('breakpoint', {
    bubbles: true, 
    cancelable: true
  });

  if (isVisible(xsD)) {
    event.breakpoint = 'xs';
  } else if (isVisible(smD)) {
    event.breakpoint = 'sm';
  } else if (isVisible(mdD)) {
    event.breakpoint = 'md';
  } else if (isVisible(lgD)) {
    event.breakpoint = 'lg';
  } else {
    event.breakpoint = 'xl';
  }

  document.dispatchEvent(event);
}

/**
 * Method: isVisible
 *
 * Checks whether the element is visible or not
 *
 * @param mixed element the element object
 * @return bool
 */
function isVisible(element)
{
  return !(element.offsetHeight === 0 && element.offsetWidth === 0);
}

// On document loaded
window.addEventListener("load", function() {
  checkBreakpoint();
});

// On resize end
window.onresize = function(event) {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
    checkBreakpoint();
  }, 250);
};
